import { render, staticRenderFns } from "./HistoryLog.vue?vue&type=template&id=3508b6e1&"
import script from "./HistoryLog.vue?vue&type=script&lang=js&"
export * from "./HistoryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports